export const dikastiriaLower = (dikastirio) => {
  if (!dikastirio) {
    return '';
  }

  const lowerCaseMap = {
    "ΑΡΕΙΟΣ ΠΑΓΟΣ": 'Άρειος Πάγος',
    'ΕΦΕΤΕΙΟ': 'Εφετείο',
    'ΠΡΩΤΟΔΙΚΕΙΟ': 'Πρωτοδικείο',
    'ΕΙΡΗΝΟΔΙΚΕΙΟ': 'Ειρηνοδικείο',
  };

  const matchKey = Object.keys(lowerCaseMap)
    .sort((a, b) => b.length - a.length)
    .find((key) => dikastirio.startsWith(key));

  if (!matchKey) {
    return dikastirio;
  }

  const rest = dikastirio.slice(matchKey.length).trim();
  return rest ? `${lowerCaseMap[matchKey]} ${rest}` : lowerCaseMap[matchKey];
};
